export const addNonceToInlineScripts = (nonce: string | undefined) => {
  if (nonce) {
    document.querySelectorAll("script.inline-script_csp-nonce-hash").forEach((script) => {
      script.setAttribute("nonce", nonce);
    });
  }
};
